<template>
  <div class="flex flex-col relative items-center w-full mt-12">
    <div class="bg-blue-default opacity-25 rounded pin-t w-80 h-48"></div>
    <div
      class="absolute pin-t z-20 bg-white w-80 mt-8 h-32 -ml-4 lg:-ml-24 shadow-md rounded flex items-center justify-center"
    >
      <BaseIcon class="text-5xl text-blue-default px-8 py-4 flex items-center" icon="chart" />
    </div>
    <div class="mt-8 text-center">
      <h2>{{ $t(`mygwf.components.User.ReportBanner.title`) }}</h2>
      <p class="mt-4 text-secondary-dark">
        {{ $t(`mygwf.components.User.ReportBanner.subtitle`) }}
      </p>
    </div>
  </div>
</template>
<script>
import {BaseIcon} from '@/components/base'
export default {
  components: {
    BaseIcon,
  },
}
</script>
